// Consent constants, text, types, and version hashing — moved to
// @lc/shared/consents so @lc/lenacareer-ai-bot's Mini App registration route
// can build the same audit rows without forking the lawyer-approved text
// (root AGENTS.md: extract a shared core both wrap). `recordConsents` below
// stays here — it is browser-only (uses `fetch` + a relative URL).
export * from "@lc/shared/consents";

import type { ConsentSubmission } from "@lc/shared/consents";

const CONSENT_AUDIT_ENDPOINT = "/api/consents";

// Fire-and-forget POST to the audit endpoint. Browser-only. Never throws —
// audit failures must not block the user from submitting the form. The
// duplicate consent payload included inside the main form submit serves
// as the second source of truth on the server side.
export async function recordConsents(submission: ConsentSubmission): Promise<void> {
  if (typeof fetch !== "function") return;
  try {
    await fetch(CONSENT_AUDIT_ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(submission),
      keepalive: true,
    });
  } catch {
    // best-effort; server-side warning will surface in logs if endpoint is down
  }
}
